// src/views/Files/FileItem/DeleteButton.tsx
import { IconButton } from "@chakra-ui/react";
import { Delete } from "@airhelp/icons";
import { jsx } from "react/jsx-runtime";
var DeleteButton = ({ onClick }) => /* @__PURE__ */ jsx(IconButton, {
  "aria-label": "Delete file",
  icon: /* @__PURE__ */ jsx(Delete, {
    color: "primary.900",
    maxW: 4,
    maxH: 4
  }),
  onClick,
  _hover: { md: { bg: "greyscale.400" } },
  _active: { bg: "greyscale.400" },
  _focus: { boxShadow: "none" },
  minW: 6,
  minH: 6,
  background: "greyscale.300",
  borderRadius: "sm",
  "data-testid": "deleteFile"
});

export {
  DeleteButton
};
